import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { EmployeeValidationContainerComponent } from './employee-validation-container/employee-validation-container.component';
import { EmployeeValidationPresenter } from './employee-validation-presenter/employee-validation-presenter.component';
import { EmployeeValidationRoute } from './employee-validation.route';

@NgModule({
    declarations: [
        EmployeeValidationContainerComponent,
        EmployeeValidationPresenter
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [EmployeeValidationRoute]
        })
    ]
})
export class EmployeeValidationModule {}
